// extracted by mini-css-extract-plugin
module.exports = {"pointWrapper":"PointText-module--pointWrapper--oyE9V","point":"PointText-module--point--2T5d6"};